/* eslint-disable react/require-default-props */
import { Select, SelectProps, makeStyles } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import React from 'react';
import { useController } from 'react-hook-form';
import { useFieldControllerContext } from './FieldControllerContext';
import { fieldHasError } from './formUtils';

const FieldSelect: React.FC<
  SelectProps & {
    notched?: boolean;
    css?: CSSProperties;
  }
> = ({ onChange, onBlur, css, multiple, ...props }) => {
  const { name, control, inputLabel } = useFieldControllerContext();
  const { fieldState, field } = useController({ name, control });
  const useStyles = makeStyles({
    paper: css || {},
  });
  const { paper } = useStyles();

  return (
    <Select
      MenuProps={{ PopoverClasses: { paper } }}
      inputRef={field.ref}
      id={name}
      name={name}
      label={inputLabel}
      onBlur={ev => {
        onBlur?.(ev);
        field.onBlur();
      }}
      onChange={(ev, value) => {
        onChange?.(ev, value);
        field.onChange(ev);
      }}
      value={field.value}
      error={fieldHasError(fieldState)}
      aria-describedby={`${name}-helper-text`}
      multiple={multiple}
      {...props}
    />
  );
};

export default FieldSelect;
